import { render } from "./list.vue?vue&type=template&id=28b2a1ae&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=28b2a1ae&scoped=true&lang=css"

import exportComponent from "E:\\Proyectos\\Front_IOSEP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b2a1ae"]])

export default __exports__